import { render } from "./DealOfTheDayCard.vue?vue&type=template&id=32cc6406"
import script from "./DealOfTheDayCard.vue?vue&type=script&lang=js"
export * from "./DealOfTheDayCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__